<template lang="html">
  <v-dialog
    v-model="dialog"
    max-width="1300px"
    scrollable
    modal
    transition="dialog-transition"
    persistent
    @keydown.enter="handleEnter"
  >
    <template #activator="{ on }">
      <v-flex
        shrink
        ma-0
        pa-0
        d-inline-flexx
        v-on="on"
      >
        <slot
          v-if="!!$slots.activator || !!$scopedSlots.activator"
          name="activator"
        />

        <v-tooltip
          v-if="!$slots.activator && !$scopedSlots.activator"
          :right="!chipsLeft"
          :left="chipsLeft"
          :disabled="!value"
        >
          <template #activator="{ on }">
            <v-btn
              text
              icon
              small
              :color="value ? 'warning' : 'grey'"
              tabindex="-1"
              v-on="on"
            >
              <v-icon v-if="value">
                call_split
              </v-icon>
              <v-icon v-else>
                arrow_upward
              </v-icon>
            </v-btn>
          </template>
          <SiConditionChips :condition="value" />
        </v-tooltip>
      </v-flex>
    </template>

    <v-card>
      <v-card-title>
        <span
          class="headline"
          v-html="title"
        />
      </v-card-title>
      <v-card-text class="pt-0">
        <SiConditionEditorCondition
          v-model="lazyValue"
          :fields="fields"
          :field-id="fieldId"
        />  
        <pre class="cyan--text text--lighten-3 grey darken-4 pa-3">{{ condition }}</pre>
        <pre class="cyan--text text--lighten-3 grey darken-4 pa-3 mt-4">{{ lazyValue }}</pre>
      </v-card-text>
      <v-card-actions>
        <v-btn
          v-if="conditionType"
          color="grey"
          text
          @click.native="clearCondition"
        >
          Remove Condition
        </v-btn>
        <v-spacer />
        <v-btn
          color="primary"
          text
          @click.native="saveMe"
        >
          Done
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import helpers from '@/mixins/helpers'
import conditionsMixins from '@/mixins/conditions'
import uniqid from 'uniqid'
export default {
  mixins: [ conditionsMixins, helpers ],
  props: {
    title: String,
    value: Object,
    fields: Object,
    fieldId: String,
    chipsLeft: Boolean
  },
  data () {
    return {
      dialog: false,
      conditionType: 'all',
      lazyValue: {},
    }
  },
  computed: {
    ...mapGetters(['_calculators']),
    condition () {
      return this._unidify(this.lazyValue)
    },
   
    defaultValue () {
      return {
          all: [{ id: uniqid(), compare: false, operator: 'equals' }]
        }
    }
  },
  watch: {
    value: {
      handler (v) {
        this.lazyValue = this._idify(v || this.newGroupTemplate())
      },
      immediate: true
    },
    lazyValue: {
      handler (v) {
        if (v.rules && v.rules.length === 0) this.reset()
      },
      deep: true
    },
    dialog (v) {
      if (!v) this.closeMe()
    }
  },
  mounted () {
    this.lazyValue = this._idify(this.value || this.newGroupTemplate())
  },
  methods: {
    reset () {
        this.lazyValue = this.newGroupTemplate()
    },
    newGroupTemplate () {
      return { 
        type: 'all',
        id: uniqid(),
        rules: [{ id: uniqid(), compare: false, operator: 'equals' }]
      }
    },
    closeMe () {
      this.dialog = false
    },
    saveMe () {
      this.$emit('input', this._unidify(this.lazyValue))
      this.$emit('change', this._unidify(this.lazyValue))
      this.closeMe()
    },
    clearCondition () {
      this.$emit('input', null)
      this.$emit('change', null)
      this.closeMe()
    },
    handleEnter (e) {
      if (e.ctrlKey) {
        this.saveMe()
      }
    },
   
  }
}
</script>

<style lang="css">
.si-compare-radio .v-input--selection-controls{
  margin-top: 0px !important;
  padding-top: 0px !important;
}

</style>
